export default __webpack_public_path__ + "static/media/coffe8.af095804.png";